import SimInfoChangeUsergroupModal from './sim-info-change-usergroup-modal.vue'
export default SimInfoChangeUsergroupModal
